async function selectorAsync(url) {
    try {
        const response = await fetch(url);
        const body = await response.json();
        return body;
    } catch (error) {
        return error;
    }
}

const selector = (url) =>
    selectorAsync(url)
        .then((body) => body)
        .catch(() => []);

export default selector;
